import { node } from 'prop-types';
import * as React from 'react';
import MenuItem from '../MenuItem';
import style from './MenuLabel.module.scss';

const MenuLabel = ({ children }) => {
  return (
    <MenuItem className={style.label} noHover>
      {children}
    </MenuItem>
  );
};

MenuLabel.propTypes = {
  children: node.isRequired,
};

export default MenuLabel;
